









import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class AppLoader extends Vue {
  @Prop() isLoading: Boolean;
}
